export default function SubscriptionItemSkeleton() {
    return (
        <div className='flex animate-pulse flex-col gap-6 overflow-hidden rounded-2xl border border-gray-200 bg-gray-50 p-4'>
            <div className='flex flex-wrap items-center gap-1'>
                <div className='flex flex-1 items-center gap-2'>
                    <div className='h-6 w-6 rounded-full bg-gray-200' />
                    <div className='h-4 w-28 rounded bg-gray-200' />
                </div>
                <div className='h-5 w-10 rounded bg-gray-200' />
            </div>

            <div className='flex flex-col gap-3'>
                {[...Array(3)].map((_, i) => (
                    <div key={i} className='flex items-center gap-2'>
                        <div className='h-4 w-4 rounded bg-gray-200' />
                        <div className='h-3 w-40 rounded bg-gray-200' />
                    </div>
                ))}
            </div>

            <div className='flex flex-col gap-2'>
                {[...Array(2)].map((_, i) => (
                    <div
                        key={i}
                        className='flex items-center justify-between rounded-xl border border-gray-200 bg-white p-3'
                    >
                        <div className='h-4 w-20 rounded bg-gray-200' />
                        <div className='h-4 w-12 rounded bg-gray-200' />
                    </div>
                ))}
            </div>

            <div className='h-10 rounded-lg bg-gray-200' />
        </div>
    );
}

